import {
  FETCH_PROGRESS_REQUEST,
  FETCH_PROJECT_PROGRESS_REQUEST,
  RECEIVE_PROGRESS,
  RECEIVE_PROGRESS_ERROR,
  RECEIVE_PROJECT_PROGRESS,
  RECEIVE_PROJECT_PROGRESS_ERROR,
  SEND_PROGRESS_ERROR,
  SEND_PROGRESS_REQUEST,
  SENT_PROGRESS_OK,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchProgress = (currentLocale, authToken) => {
  return createApiAction({
    endpoint: `/${currentLocale}/progress`,
    types: [FETCH_PROGRESS_REQUEST, RECEIVE_PROGRESS, RECEIVE_PROGRESS_ERROR],
    currentLocale,
    authToken,
  })
}

export const fetchProjectProgress = (
  currentLocale,
  authToken = null,
  slug,
  session
) => {
  return createApiAction({
    endpoint: `/${currentLocale}/progress/${slug}?session_progress=${session}`,
    types: [
      FETCH_PROJECT_PROGRESS_REQUEST,
      RECEIVE_PROJECT_PROGRESS,
      RECEIVE_PROJECT_PROGRESS_ERROR,
    ],
    currentLocale,
    authToken,
  })
}

const completionArray = (completion) =>
  Array.isArray(completion) ? completion : completion.length ? [completion] : []

export const createProgress = (
  currentLocale,
  authToken,
  projectId,
  slug,
  step,
  completion = '',
  session,
  actions = {}
) => {
  return createApiAction({
    endpoint: `/${currentLocale}/progress`,
    types: [SEND_PROGRESS_REQUEST, SENT_PROGRESS_OK, SEND_PROGRESS_ERROR],
    method: 'POST',
    data: {
      projectId,
      id: slug,
      step,
      completion: completionArray(completion),
      session_progress: session,
    },
    currentLocale,
    authToken,
    actions,
  })
}

export const updateProgress = (
  currentLocale,
  authToken,
  projectId,
  slug,
  step,
  completion = '',
  session,
  actions = {}
) => {
  return createApiAction({
    endpoint: `/${currentLocale}/progress/${slug}`,
    types: [SEND_PROGRESS_REQUEST, SENT_PROGRESS_OK, SEND_PROGRESS_ERROR],
    method: 'PUT',
    data: {
      projectId,
      step,
      completion: completionArray(completion),
      session_progress: session,
    },
    currentLocale,
    authToken,
    actions,
  })
}
